<template>
	<Col class="width-100 height-100 dialog-content flex-justify-space-between pt-6 px-5 pb-5">
		<Col class="overflow-y-auto overflow-x-hidden">
			<div class="title-text mb-1">Feature description</div>
			<h5 class="reg mb-2 help-users">Help users use this feature. Displayed when the user sees the feature for the first time.</h5>
			<OnboardingTextPreview
				class="mb-6 text-preview"
				:text="newOnboardingText"
				:creatorName="user.first_name"
				@onOnboardingTextUpdated="(v) => (newOnboardingText = v)"
			/>
			<FeatureDescriptionPreview :workflow="workflow" :onboardingText="newOnboardingText" />
		</Col>
		<div class="dialog-bottom flex-centerize mt-2">
			<AnemicButton class="save-button pa-0" :disabled="isLoading" :loading="isLoading" tile @click="saveOnboardingText">
				Save
			</AnemicButton>
		</div>
	</Col>
</template>

<script>
import { mapGetters } from 'vuex';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { updateWorkflow } from '@/store/modules/workflows/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import OnboardingTextPreview from '../ShareModuleDialog/OnboardingText/OnboardingTextPreview';
import FeatureDescriptionPreview from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview.vue';
export default {
	name: 'OnboardingFeatureDescriptionDialogContent',
	components: {
		OnboardingTextPreview,
		FeatureDescriptionPreview,
	},
	props: {
		workflowId: { type: Number, required: true },
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ useWorkflow: getWorkflow }),
		workflow() {
			return this.useWorkflow(this.workflowId);
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflow }),
		async saveOnboardingText() {
			const currentSettings = this.workflow?.onboarding_settings || {};
			currentSettings.text = this.newOnboardingText;
			this.isLoading = true;
			try {
				await this.updateWorkflow({ id: this.workflow.id, data: { onboarding_settings: currentSettings } });
				this.$emit('close');
			} catch {
				this.$toast.error('Failed to save, please try again later');
			} finally {
				this.isLoading = false;
			}
		},
	},
	mounted() {
		this.newOnboardingText = this.workflow?.onboarding_settings.text;
	},
	data() {
		return {
			isLoading: false,
			newOnboardingText: '',
		};
	},
};
</script>

<style scoped lang="scss">
.title-text {
	font-size: 18px;
	font-weight: 600;
	text-align: left;
	color: var(--primary-font-color);
}
.dialog-content {
	width: 620px;
	height: 655px;
	border-radius: 10px;
	background: #ffffff;
}
.save-button {
	width: 140px !important;
	height: 45px !important;
	font-size: 14px !important;
	color: #ffffff !important;
	font-weight: 400 !important;
	letter-spacing: 0px !important;
	border-radius: 10px !important;
	text-transform: none !important;
	background: #5858ec !important;
	border: 1px solid #5858ec !important;
	&:disabled {
		border: unset !important;
	}
}
</style>
